var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPowerpoint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9417 4.87529L11.5527 1.47187C11.1891 1.10678 10.6963 0.899902 10.1833 0.899902H1.93891C0.868471 0.903959 0 1.77611 0 2.85109V19.7262C0 20.8012 0.868471 21.6733 1.93891 21.6733H13.5724C14.6428 21.6733 15.5113 20.8012 15.5113 19.7262V6.2545C15.5113 5.73932 15.3053 5.24037 14.9417 4.87529ZM13.4148 6.0963H10.3409V3.00929L13.4148 6.0963ZM1.93891 19.7262V2.85109H8.40195V7.06986C8.40195 7.60938 8.83416 8.04342 9.3714 8.04342H13.5724V19.7262H1.93891Z",
    fill: "#95AAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.98953 13.842V15.364H5.90813V10.8782H7.69814C8.04114 10.8782 8.3441 10.9419 8.607 11.0692C8.87196 11.1945 9.07632 11.3742 9.2201 11.6084C9.36593 11.8405 9.43884 12.1044 9.43884 12.4002C9.43884 12.8376 9.28172 13.1878 8.96747 13.4507C8.65527 13.7116 8.226 13.842 7.67965 13.842H6.98953ZM6.98953 13.0071H7.69814C7.90764 13.0071 8.06682 12.9547 8.17567 12.85C8.28659 12.7452 8.34204 12.5973 8.34204 12.4063C8.34204 12.1968 8.28556 12.0294 8.17259 11.9041C8.05963 11.7788 7.90558 11.7152 7.71046 11.7131H6.98953V13.0071Z",
    fill: "#95AAC9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.5113,
    height: 20.7694,
    fill: "white",
    transform: "translate(0 0.904785)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerpoint);
export default __webpack_public_path__ + "static/media/powerpoint.1f908fbc1d65b43bcce5c29e1b67846c.svg";
export { ForwardRef as ReactComponent };